import { Router } from '@angular/router';
import { Component } from '@angular/core';

import { RouterHelperService } from '@core/services/router-helper/router-helper.service';
import { AnalyticsService } from '@core/services/app/analytics.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  standalone: false,
})
export class PageNotFoundComponent {
  constructor(
    private router: Router,
    private readonly routerHelper: RouterHelperService,
    private readonly analyticsService: AnalyticsService,
  ) {}

  navigateToHome(): void {
    this.router.navigate([this.routerHelper.translateRoute('/')]);
  }
}
